import api from './api';

export interface Notification {
  id: number;
  user_id: number;
  title: string;
  message: string;
  type: 'info' | 'success' | 'warning' | 'error';
  category?: string;
  is_read: number;
  link?: string;
  metadata?: any;
  created_at: string;
  read_at?: string;
}

export interface NotificationResponse {
  notifications: Notification[];
  unreadCount: number;
}

export interface CreateNotificationData {
  user_id?: number;
  role?: string;
  title: string;
  message: string;
  type?: 'info' | 'success' | 'warning' | 'error';
  category?: string;
  link?: string;
  metadata?: any;
}

export const notificationService = {
  getMyNotifications: async (params?: {
    limit?: number;
    offset?: number;
    is_read?: number;
  }): Promise<NotificationResponse> => {
    const response = await api.get('/notifications/my', { params });
    return response.data;
  },

  getUnreadCount: async (): Promise<{ count: number }> => {
    const response = await api.get('/notifications/unread-count');
    return response.data;
  },

  markAsRead: async (id: number): Promise<{ message: string }> => {
    const response = await api.put(`/notifications/${id}/read`);
    return response.data;
  },

  markAllAsRead: async (): Promise<{ message: string; count: number }> => {
    const response = await api.put('/notifications/mark-all-read');
    return response.data;
  },

  deleteNotification: async (id: number): Promise<{ message: string }> => {
    const response = await api.delete(`/notifications/${id}`);
    return response.data;
  },

  deleteAll: async (): Promise<{ message: string; count: number }> => {
    const response = await api.delete('/notifications/all/clear');
    return response.data;
  },

  // Admin only
  createNotification: async (data: CreateNotificationData): Promise<{ message: string; id: number }> => {
    const response = await api.post('/notifications', data);
    return response.data;
  },

  createForRole: async (data: CreateNotificationData): Promise<{ message: string; count: number }> => {
    const response = await api.post('/notifications/role', data);
    return response.data;
  },

  createForAll: async (data: CreateNotificationData): Promise<{ message: string; count: number }> => {
    const response = await api.post('/notifications/broadcast', data);
    return response.data;
  },
};
